<template>
  <v-layout row justify-center>
    <v-dialog v-model="exibirDetalheGuia" persistent max-width="800">
      <v-card>
        <v-toolbar class="elevation-1">
          <v-toolbar-title>Guia {{ guiaDetalhe.statusGuia }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="fecharModal">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-4">
          <v-layout row wrap class="my-2">
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">Status da guia</v-flex>
                <v-flex lg12>{{
                  guiaDetalhe.statusGuia || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg8 xs12 v-if="hasCartaNegativa">
              <v-btn
                dark
                class="white--text"
                color="primary"
                @click="baixarCartaNegativa"
              >
                Baixar carta de negativa
              </v-btn>
            </v-flex>
            <v-flex lg8 xs12 v-if="!hasCartaNegativa">
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold"
                  >Status Carta Negativa</v-flex
                >
                <v-flex lg12>{{
                  statusCartaNegativa || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg4 xs12 v-if="hasCartaNegativa || hasStatusCartaNegativa">
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">Senha</v-flex>
                <v-flex lg12>{{ guiaDetalhe.senha || "Não informado" }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg4 xs12 v-if="hasCartaNegativa || hasStatusCartaNegativa">
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold"
                  >Data de validade da senha</v-flex
                >
                <v-flex lg12>{{
                  guiaDetalhe.validadeSenha || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-2">
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">Caráter</v-flex>
                <v-flex lg12>{{
                  guiaDetalhe.carater || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold"
                  >Tipo de solicitação</v-flex
                >
                <v-flex lg12>{{
                  guiaDetalhe.tipoSolicitacao || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold"
                  >Data de solicitação</v-flex
                >
                <v-flex lg12>{{
                  guiaDetalhe.dataSolicitacao || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-2">
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">Unimed executora</v-flex>
                <v-flex lg12>{{
                  guiaDetalhe.unimedExecutora || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">Nível</v-flex>
                <v-flex lg12>{{ guiaDetalhe.nivel || "Não informado" }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">Nome prestador</v-flex>
                <v-flex lg12>{{
                  guiaDetalhe.prestador || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-2">
            <v-flex lg4 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">Município</v-flex>
                <v-flex lg12>{{
                  guiaDetalhe.municipio || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg8 xs12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold">UF</v-flex>
                <v-flex lg12>{{ guiaDetalhe.uf || "Não informado" }}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-2">
            <v-flex lg12>
              <v-layout row wrap>
                <v-flex lg12 class="font-weight-bold"
                  >Identificação clínica</v-flex
                >
                <v-flex lg12>{{
                  guiaDetalhe.indicacaoClinica || "Não informado"
                }}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "GuiaDetalhe",
  props: {
    exibirDetalheGuia: Boolean,
    guiaDetalhe: Object
  },
  computed: {
    hasCartaNegativa() {
      return this.guiaDetalhe?.cartaNegativa?.permiteDownload;
    },
    statusCartaNegativa() {
      return this.guiaDetalhe?.cartaNegativa?.status;
    }
  },
  methods: {
    baixarCartaNegativa() {
      this.$emit("baixar-carta-negativa");
    },
    fecharModal() {
      this.$emit("fechar-modal");
    }
  }
};
</script>
